<template>
  <v-app style="background-color: #e2e2e5; min-height: 100vh">
    <v-app-bar app color="white">
      <div
          class="flex justify-center mb-1 mt-1"
          style="max-height: 3rem; max-width: 3rem"
      >
        <img
            src="../../assets/img/MOH_logo.png"
            style="max-height: 3rem; max-width: 3rem"
        />
      </div>
      <v-spacer/>
      <div class="v-toolbar__title headline ml-2 w-auto">
        <span class="primary--text">Human Resource Development </span>
      </div>
      <v-spacer/>
    </v-app-bar>
    <v-main>
      <div class="flex justify-center">
        <div class="self-center justify-center text-center" style="width: 90%">
          <h4>Trainer Information</h4>
        </div>
      </div>

      <v-card class="mx-6" elevation="2" style="min-height: 40vh; ">
        <v-container class="p-7">
          <v-row>
            <v-col lg="6" md="12" sm="12">
              <div class="flex">
                <div class="w-1/2 h-12">
                  <p class="text-md-right font-weight-bold pr-2">
                    Full Name:
                  </p>
                </div>

                <v-divider vertical></v-divider>

                <div class="w-1/2 h-12">
                  <p class="font-weight-small pl-2">
                    {{
                      trainerInformation.trainerName
                          ? trainerInformation.trainerName
                          : "-"
                    }}
                    {{
                      trainerInformation.trainerFatherName
                          ? trainerInformation.trainerFatherName
                          : "-"
                    }}
                    {{
                      trainerInformation.trainerGrandfatherName
                          ? trainerInformation.trainerGrandfatherName
                          : "-"
                    }}
                  </p>
                </div>
              </div>
              <div class="flex">
                <div class="w-1/2 h-12">
                  <p class="text-md-right font-weight-bold pr-2">
                    Gender:
                  </p>
                </div>

                <v-divider vertical></v-divider>

                <div class="w-1/2 h-12">
                  <p class="font-weight-small pl-2">
                    {{
                      trainerInformation.gender
                          ? trainerInformation.gender
                          : "-"
                    }}
                  </p>
                </div>
              </div>
              <div class="flex">
                <div class="w-1/2 h-12">
                  <p class="text-md-right font-weight-bold pr-2">
                    Phone Number:
                  </p>
                </div>

                <v-divider vertical></v-divider>

                <div class="w-1/2 h-12">
                  <p class="font-weight-small pl-2">
                    {{
                      trainerInformation.phoneNumber
                          ? trainerInformation.phoneNumber
                          : "-"
                    }}
                  </p>
                </div>
              </div>
              <div class="flex">
                <div class="w-1/2 h-12">
                  <p class="text-md-right font-weight-bold pr-2">
                    Email:
                  </p>
                </div>

                <v-divider vertical></v-divider>

                <div class="w-1/2 h-12">
                  <p class="font-weight-small pl-2">
                    {{
                      trainerInformation.email ? trainerInformation.email : "-"
                    }}
                  </p>
                </div>
              </div>
            </v-col>
            <v-col lg="6" md="12" sm="12">
              <div class="flex">
                <div class="w-1/2 h-12">
                  <p class="text-md-right font-weight-bold pr-2">
                    CPD Activity:
                  </p>
                </div>

                <v-divider vertical></v-divider>

                <div class="w-1/2 h-12">
                  <p class="font-weight-small pl-2">
                    {{
                      trainerInformation.cpdActivity
                          ? trainerInformation.cpdActivity
                          : "-"
                    }}
                  </p>
                </div>
              </div>
              <div class="flex">
                <div class="w-1/2 h-12">
                  <p class="text-md-right font-weight-bold pr-2">
                    Course Name:
                  </p>
                </div>

                <v-divider vertical></v-divider>

                <div class="w-1/2 h-12">
                  <p class="font-weight-small pl-2">
                    {{
                      trainerInformation.courseName
                          ? trainerInformation.courseName
                          : "-"
                    }}
                  </p>
                </div>
              </div>
              <div class="flex">
                <div class="w-1/2 h-12">
                  <p class="text-md-right font-weight-bold pr-2">
                    Continual Education Unit:
                  </p>
                </div>

                <v-divider vertical></v-divider>

                <div class="w-1/2 h-12">
                  <p class="font-weight-small pl-2">
                    {{
                      trainerInformation.continualEducationUnit
                          ? trainerInformation.continualEducationUnit
                          : "-"
                    }}
                  </p>
                </div>
              </div>
              <div class="flex">
                <div class="w-1/2 h-12">
                  <p class="text-md-right font-weight-bold pr-2">
                    Continual Code:
                  </p>
                </div>

                <v-divider vertical></v-divider>

                <div class="w-1/2 h-12">
                  <p class="font-weight-small pl-2">
                    {{
                      trainerInformation.courseCode
                          ? trainerInformation.courseCode
                          : "-"
                    }}
                  </p>
                </div>
              </div>
              <div class="flex">
                <div class="w-1/2 h-12">
                  <p class="text-md-right font-weight-bold pr-2">
                    Course Owner:
                  </p>
                </div>

                <v-divider vertical></v-divider>

                <div class="w-1/2 h-12">
                  <p class="font-weight-small pl-2">
                    {{
                      trainerInformation.trainingCenterName
                          ? trainerInformation.trainingCenterName
                          : "-"
                    }}
                  </p>
                </div>
              </div>
              <div class="flex">
                <div class="w-1/2 h-12">
                  <p class="text-md-right font-weight-bold pr-2">
                    Certificate Reason:
                  </p>
                </div>

                <v-divider vertical></v-divider>

                <div class="w-1/2 h-12">
                  <p class="font-weight-small pl-2">
                    {{ trainerInformation?.certificateReason ?? "-" }}
                  </p>
                </div>
              </div>
              <div class="flex">
                <div class="w-1/2 h-12">
                  <p class="text-md-right font-weight-bold pr-2">
                    Course Issue Date:
                  </p>
                </div>

                <v-divider vertical></v-divider>

                <div class="w-1/2 h-12">
                  <p class="font-weight-small pl-2">
                    {{ trainerInformation?.courseCompletionDate ?? "-" }}
                  </p>
                </div>
              </div>
              <div class="flex">
                <div class="w-1/2 h-12">
                  <p class="text-md-right font-weight-bold pr-2">
                    Course Accreditor:
                  </p>
                </div>

                <v-divider vertical></v-divider>

                <div class="w-1/2 h-12">
                  <p class="font-weight-small pl-2">
                    {{
                      trainerInformation.accreditorName
                          ? trainerInformation.accreditorName
                          : "-"
                    }}
                  </p>
                </div>
              </div>
              <div class="flex">
                <div class="w-1/2 h-12">
                  <p class="text-md-right font-weight-bold pr-2">
                    Accreditation Date:
                  </p>
                </div>

                <v-divider vertical></v-divider>

                <div class="w-1/2 h-12">
                  <p class="font-weight-small pl-2">
                    {{ trainerInformation?.accrediationDate ?? "-" }}
                  </p>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-main>
  </v-app>
</template>

<script>
import {TrainerService} from "./trainers.service";

export default {
  data() {
    return {
      trainerInformation: {
        trainerName: null,
        trainerFatherName: null,
        trainerGrandfatherName: null,
        gender: null,
        phoneNumber: null,
        email: null,
        courseName: null,
        continualEducationUnit: null,
        courseCode: null,
        trainingCenterName: null,
        accreditorName: null,
        cpdActivity: null
      },
      loading: false,
    };
  },
  async created() {
    this.loading = true;
    const trainerId = this.$route.params.id;
    const category = this.$route.params.category;
    const courseId = this.$route.params.courseId;
    try {
      // The service unwraps the API response and returns the public profile.
      const trainerInformation = await TrainerService.getPublicTrainerInfo(trainerId, category, courseId);
      if (!trainerInformation) {
        throw new Error("Trainer information was not found");
      }
      this.trainerInformation = trainerInformation;
    } catch (e) {
      console.error(e);
      this.$toast?.error?.(
          "There was a problem fetching trainer information, Please try again!"
      );
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style scoped>
.wrapper {
  align-items: center;
  background-color: #e2e2e5;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
}

h4 {
  font-family: sans-serif;
  margin: 1.5rem auto;
  color: gray;
  text-align: center;
  font-size: 30px;
  max-width: 100%;
  position: relative;
}

h4:before {
  content: "";
  display: block;
  width: 28%;
  height: 3px;
  background: #0e74b8;
  left: 0;
  top: 50%;
  position: absolute;
}

h4:after {
  content: "";
  display: block;
  width: 28%;
  height: 3px;
  background: #0e74b8;
  right: 0;
  top: 50%;
  position: absolute;
}

@media only screen and (max-width: 600px) {
  h4:before {
    display: none;
  }

  h4:after {
    display: none;
  }
}
</style>
